import AxiosService from '../../../gateway/rest/AxiosService'

class MssqlCachingRestService {
  static async getCacheConfig(policyId: number) {
    return AxiosService.get(`/adaptermssql/cache/policies/${policyId}`)
  }

  static async setCacheConfig(cacheConfig: any) {
    return AxiosService.post('/adaptermssql/cache/policies/', cacheConfig)
  }
}

export default MssqlCachingRestService
